import { render, staticRenderFns } from "./zgy-mask.vue?vue&type=template&id=2e80da55&scoped=true&"
import script from "./zgy-mask.vue?vue&type=script&lang=js&"
export * from "./zgy-mask.vue?vue&type=script&lang=js&"
import style0 from "./zgy-mask.vue?vue&type=style&index=0&id=2e80da55&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e80da55",
  null
  
)

export default component.exports